/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_PrivacyInputs */



/**
* | output |
* | --- |
* | "Retention window and member /opt-out" |
*
* @param {Pricing_Compare_PrivacyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_privacy = /** @type {((inputs?: Pricing_Compare_PrivacyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_PrivacyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Срок хранения и /не-учитывать-меня для участников")
	return /** @type {LocalizedString} */ ("Retention window and member /opt-out")
});